"use client";

import { motion } from "motion/react";
import { useTranslations } from "next-intl";

export default function FormSectionEyebrow() {
    const t = useTranslations();
    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center justify-center gap-3 sm:gap-4 mb-10 sm:mb-14"
        >
            <span className="hidden sm:block w-10 h-px bg-gradient-to-r from-transparent to-primary/50" />
            <span className="text-[10px] uppercase tracking-[0.28em] text-primary font-mono">
                01 · {t("joinInstructor_process_step1_title")}
            </span>
            <span className="hidden sm:block w-10 h-px bg-gradient-to-l from-transparent to-primary/50" />
        </motion.div>
    );
}
